import type { App } from 'vue'

import { env } from '@/utils/env'

let appInstance: App | null = null
let cookieConsentReady: Promise<void> | null = null
let plausibleReady: Promise<void> | null = null
let plausibleDevNoticeShown = false

function getAppInstance() {
  return appInstance
}

export function startDeferredClientModules(app: App) {
  if (typeof window === 'undefined') return

  appInstance = app

  void ensurePlausibleReady()
}

export function ensureCookieConsentReady() {
  if (typeof window === 'undefined') return Promise.resolve()
  if (cookieConsentReady) return cookieConsentReady

  cookieConsentReady = (async () => {
    const app = getAppInstance()
    if (!app) return

    const [
      { default: CookieConsentPlugin },
      { createCookieConsentConfig, syncInitialConsent },
    ] = await Promise.all([
      import('@/plugins/cookie-consent.ts'),
      import('@/config/cookieconsent/config'),
      import('vanilla-cookieconsent/dist/cookieconsent.css'),
      import('../../assets/css/overrides.css'),
    ])

    app.use(CookieConsentPlugin, {
      getConfig: (currentApp: App) => createCookieConsentConfig(currentApp),
    })

    syncInitialConsent()
  })()

  return cookieConsentReady
}

export async function showCookieConsentIfNeeded() {
  if (typeof window === 'undefined') return

  await ensureCookieConsentReady()

  const CookieConsent = await import('vanilla-cookieconsent')

  if (!CookieConsent.validConsent()) {
    CookieConsent.show(true)
  }
}

function ensurePlausibleReady() {
  if (typeof window === 'undefined') return Promise.resolve()
  if (env.isDev) {
    if (!plausibleDevNoticeShown) {
      console.info('[Plausible disabled in dev]')
      plausibleDevNoticeShown = true
    }

    return Promise.resolve()
  }

  if (plausibleReady) return plausibleReady

  plausibleReady = (async () => {
    const app = getAppInstance()
    if (!app) return

    const { plausible } = await import('@/config/plausible-config')
    app.use(plausible)
  })()

  return plausibleReady
}
